export const DEFAULT_PASSWORD_POLICY_REGEX =
  "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).{8,}$";
export const DEFAULT_PASSWORD_POLICY_MESSAGE =
  "Password must be at least 8 characters and include uppercase, lowercase, and a number";

export function normalizePasswordPolicyRegex(regex) {
  return typeof regex === "string" && regex.trim()
    ? regex.trim()
    : DEFAULT_PASSWORD_POLICY_REGEX;
}

export function passwordMatchesPolicy(password, regex) {
  try {
    return new RegExp(normalizePasswordPolicyRegex(regex)).test(password || "");
  } catch (error) {
    return false;
  }
}

export function passwordPolicyPrompt(message) {
  return typeof message === "string" && message.trim()
    ? message.trim()
    : DEFAULT_PASSWORD_POLICY_MESSAGE;
}
